import {useState} from 'react'

function useModal() {
  const [isShowing, setIsShowing] = useState(false)

  function toggle() {
    setIsShowing(!isShowing)
  }

  return {
    setIsShowing,
    isShowing,
    toggle,
  }
}

export default useModal
